import { useTranslation } from 'react-i18next';
import type { AuditLogActor } from '../model/types';
import { formatActor } from '../lib/format';

interface AuditActorCellProps {
  actor: AuditLogActor;
  onUserClick?: (userId: number) => void;
}

export function AuditActorCell({ actor, onUserClick }: AuditActorCellProps) {
  const { t } = useTranslation('cabinet');
  const formatted = formatActor(actor, t);
  const userId = actor.userId;

  return (
    <div className="min-w-0">
      <div className="truncate text-sm text-foreground">{formatted.title}</div>
      {formatted.detail ? (
        userId != null && onUserClick ? (
          <button
            type="button"
            className="truncate text-xs text-primary hover:underline"
            onClick={(event) => {
              event.stopPropagation();
              onUserClick(userId);
            }}
          >
            {formatted.detail}
          </button>
        ) : (
          <div className="truncate text-xs text-muted-foreground">{formatted.detail}</div>
        )
      ) : null}
    </div>
  );
}
